import { addReaction } from '@storeOld/reducers/shared'
import { useDispatch } from 'react-redux'

import { useAuth } from '@/hooks'

const useSetReaction = () => {
  const auth = useAuth()
  const dispatch = useDispatch()

  return (payload: { commentId: string; emoji: string }) => {
    const action = addReaction({
      comment: payload.commentId,
      reaction: {
        emoji: payload.emoji,
        user: {
          id: auth.id,
          fullName: auth.fullName,
        },
      },
    })

    // @todo implement actions
    // @ts-expect-error
    dispatch(action)
  }
}

export default useSetReaction
